import { render, staticRenderFns } from "./cyprus.vue?vue&type=template&id=1d6c80c8&scoped=true&"
import script from "./cyprus.vue?vue&type=script&lang=js&"
export * from "./cyprus.vue?vue&type=script&lang=js&"
import style0 from "./cyprus.vue?vue&type=style&index=0&id=1d6c80c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6c80c8",
  null
  
)

export default component.exports